import { gql } from '@apollo/client';

export default gql`
  mutation ExecuteSystemAction($advisor_id: Int!, $input: ExecuteSystemActionInput!) {
    executeSystemAction(advisor_id: $advisor_id, input: $input) {
      success
      log_entry {
        id
        advisor_id
        provider_id
        provider_name
        action_type
        status
        scheduled_at
        executed_at
        triggered_by
        triggered_by_name
        mail_content
        is_manual_edit
        createdAt
      }
      message
    }
  }
`;
